export default {
    imageDashboardTransaction: {
        action: 'Action',
        transactionId: 'Identifiant de transaction',
        variationCount: 'Nombre de variations',
        date: 'Date',
        cost: 'Coût',
        description: 'Description',
        selectedImage: 'Image sélectionnée',
        goTo: 'Aller à',
    },
};
